import type {AuthorityField008Definitions} from 'typings/portaro.be.types';
import {AuthorityField8EditorService} from './authority-field8-editor.service';

export function authorityField8EditorServiceFactory(): AuthorityField8EditorServiceFactory {
    return {
        createService(definitions: AuthorityField008Definitions): AuthorityField8EditorService {
            return new AuthorityField8EditorService(definitions);
        }
    }
}

authorityField8EditorServiceFactory.factoryName = 'authorityField8EditorServiceFactory';

export interface AuthorityField8EditorServiceFactory {
    createService(definitions: AuthorityField008Definitions): AuthorityField8EditorService
}